var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.567,
    height: 16.581,
    viewBox: "0 0 16.567 16.581",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone-icon",
    transform: "translate(4.275 -0.202) rotate(22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12284",
    "data-name": "Group 12284",
    transform: "translate(0.539 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37876",
    "data-name": "Path 37876",
    d: "M12.924,9.354,11.146,7.575a1.183,1.183,0,0,0-1.969.445,1.21,1.21,0,0,1-1.4.762,5.485,5.485,0,0,1-3.3-3.3,1.151,1.151,0,0,1,.762-1.4,1.183,1.183,0,0,0,.445-1.969L3.9.334a1.269,1.269,0,0,0-1.715,0L.982,1.54c-1.207,1.27.127,4.637,3.113,7.623s6.352,4.383,7.623,3.113l1.207-1.207A1.269,1.269,0,0,0,12.924,9.354Z",
    transform: "translate(-0.539 0)",
    fill: "#1768d6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.7036bfe3.svg";
export { ForwardRef as ReactComponent };